export interface SolunoActivityCode {
	id: string;
	description: string;
	type?: SolunoActivityCodeTypes;
	GLAccount?: SolunoGLAccount;
}

export enum SolunoActivityCodeTypes {
	FEE = 'FEE',
	DISBURSEMENT = 'DISBURSEMENT',
	FEE_AND_DISBURSEMENT = 'FEE_AND_DISBURSEMENT',
	NA = 'N/A',
}

export interface SolunoGLAccount {
	id: string;
	accountDescription: string;
	department: string;
	category: string;
	costCenter: string;
	accountType: string;
	accountUsageType: string;
	showInHelp: boolean;
}
